import * as React from "react";
import { IconCloudDemo } from "@/components/IconCloudDemo";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/lib/userType.js";
import ToggleTheme from "@/components/ToggleTheme.js";
import AuthForm from "./AuthForm.js";

const Authentication = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-background text-foreground">
      <div className="absolute right-10 flex items-center gap-2 top-16">
        <ToggleTheme />
      </div>

      <img
        src="https://i.ibb.co/kgcSt8P/logo.png"
        alt="logo"
        className="ml-5 size-40"
      />

      <IconCloudDemo />

      {/* Right side with login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-4 md:p-8">
        <div className="w-full max-w-md space-y-6 md:space-y-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-4xl font-bold tracking-wider">
              Welcome to E-Skills Web
            </h1>
          </div>

          <AuthForm />
        </div>
      </div>
    </div>
  );
};

export default Authentication;
